import { ACTIVE_COMPSET_KEY_NAME, AUTH_TOKEN_NAME } from "@/constants";

export const getActiveCompset = () => localStorage.getItem(ACTIVE_COMPSET_KEY_NAME);
export const storeActiveCompset = (value) => {
    localStorage.setItem(ACTIVE_COMPSET_KEY_NAME, value)
}
export const removeActiveCompset = () => localStorage.removeItem(ACTIVE_COMPSET_KEY_NAME);


export const getAccessToken = () => localStorage.getItem(AUTH_TOKEN_NAME);
export const storeAccessToken = (value) => {
    localStorage.setItem(AUTH_TOKEN_NAME, value)
}
export const removeAccessToken = () => localStorage.removeItem(AUTH_TOKEN_NAME);
